import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import auth from './auth'
import manageNews from './manage-news'
import report from './report'
import admin from './admin'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    auth,
    manageNews,
    report,
    admin
  },
  strict: process.env.DEV,
})
